/**
 * Endpoint methods related to the Products
 */
 import API from "./Api";

export default{
    /**
     * Gets a product by the slug
     */
    async getBySlug(slug) {
        return API.post("productsbyslug", slug, "PLAIN_JSON");
    },
}